import { Link } from 'gatsby';
import React from 'react';

const NavLink = ({ label, to, active, className }) => (
  <Link className={`nav-link text-muted ${active ? '-active' : ''}  ${className}`} activeClassName="-active" to={to}>
    <div>{label}</div>
  </Link>
);

export default NavLink;